import { QueryCache, MutationCache, QueryClient } from "@tanstack/react-query";
import { HOUR, QUERY_RETRY_ATTEMPTS } from "../constants/queryCacheTimes";

import { logger } from "../utils/logger";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 12 * HOUR,
      retry: QUERY_RETRY_ATTEMPTS,
    },
  },
  queryCache: new QueryCache({
    onError: logger,
  }),
  mutationCache: new MutationCache({
    onError: logger,
  }),
});

export { queryClient };
